import {FINANCING_ENDING_BULK_OPERATION_STATE} from '@dms/api/sales';

export const FINANCING_ENDING_RUNNING_OPERATION_STATES: readonly string[] = [
  FINANCING_ENDING_BULK_OPERATION_STATE.PENDING,
  FINANCING_ENDING_BULK_OPERATION_STATE.IN_PROGRESS,
];
